import { connect } from 'react-redux';

import BrowseLinks from './browse-links';

const mapState = ({ browseLinks, baseConfig: { device, pageType }, page }) => ({
    browseLinks,
    deviceType: device?.type,
    isAppView: Boolean(page?.appViewDevice),
    pageType,
});

export default connect(mapState)(BrowseLinks);
